import { Container, Skeleton, Stack } from '@mui/material';
import { LogosHeader } from '../../components/LogosHeader';

/**
 * Skeleton component that mimics HomePage structure
 *
 * Displays a skeleton version of HomePage while the app is initializing.
 * Matches the visual layout of the real HomePage to provide continuity
 * during the loading phase.
 *
 * Structure:
 * - Top section: Real logos and text skeleton (centered)
 * - Bottom section: Two button skeletons (fixed at bottom)
 *
 * Usage:
 * ```
 * {swLoader.isInitializing && <HomePageSkeleton />}
 * ```
 */
export const HomePageSkeleton = () => {
  return (
    <>
      {/* Top section: Real logos */}
      <LogosHeader sx={{ p: 2 }} />

      {/* Bottom section: Button skeletons */}
      <Container
        sx={{
          p: '1 0',
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          top: 'auto',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 1,
        }}
        maxWidth="md"
      >
        <Stack
          direction="row"
          spacing={1}
          padding={1}
          sx={{ width: '100%' }}
          aria-label="Chargement des boutons de navigation"
        >
          {/* First button skeleton */}
          <Skeleton
            variant="rectangular"
            sx={{ flexGrow: 1, height: 48 }}
            aria-label="Chargement du bouton Liste des logements"
          />
          {/* Second button skeleton */}
          <Skeleton
            variant="rectangular"
            sx={{ flexGrow: 1, height: 48 }}
            aria-label="Chargement du bouton Nouveau logement"
          />
        </Stack>
      </Container>
    </>
  );
};
